export default {
    issues: {
        expired: 0,
        pending: 0,
        unassigned: 0
    }
};
